import React, { useState, useEffect } from 'react';
import OverviewComponent from '../overviewComponent/OverviewComponent';
import './DetailsComponent.scss';

function DetailsComponent({ action, detailsPath }) {
  const [cards, setCards] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    fetch(detailsPath)
      .then((result) => result.text())
      .then((result) => {
        const htmlObject = document.createElement('div');
        htmlObject.innerHTML = result;
        const objects = [];
        let detailsOverviewCards = {};
        const elements = htmlObject.querySelectorAll(
          '.contentWell.aem-GridColumn.aem-GridColumn--default--12'
        );
        let key = 0;
        Array.from(elements).forEach((ele) => {
          const obj = {};
          const titleEle = ele.querySelector('h3.details-content-card-title');
          key += 1;
          obj.key = key;
          obj.title = titleEle.innerText;
          titleEle.remove();
          const contentWellSpanEle = ele.querySelector('.content-well-author-message');
          contentWellSpanEle && contentWellSpanEle.remove();
          obj.content = ele.innerHTML;
          objects.push(obj);
        });
        detailsOverviewCards = objects;
        setCards(detailsOverviewCards);
        setDataLoaded(true);
      });
  }, [detailsPath]);

  if (dataLoaded) {
    return (
      <div className="details-container">
        <div className="details-content">
          <button
            type="button"
            className="details-closeBtn"
            aria-label="Close"
            onClick={() => action(0)}
          >
            <span aria-hidden="true">x</span>
          </button>
          {cards &&
            Object.entries(cards).map((details) => {
              return (
                <OverviewComponent
                  titleText={details[1].title}
                  content={details[1].content}
                  key={details[1].key}
                  item={details[1].key}
                />
              );
            })}
        </div>
      </div>
    );
  }
  return <div />;
}

export default DetailsComponent;
